<div class="row justify-content-center">
  <div class="col-md-10">
    <div class="card card-secondary">
      <div class="card-header">
        <h4 class="card-title w-100">
          <span>Assistant Invitations</span>
        </h4>
      </div>
    </div>
    <ng-container *ngIf="showAddButton">
      <div class="text-right mb-2">
        <input type="button" class="btn btn-secondary input-block-level" value="Add Invitation" (click)="onAddClicked()">
      </div>
    </ng-container>
    <div class="row admin-box" *ngIf="showList">
      <div #gridWrapper class="col-md-12">
        <ag-grid-angular style="height: 500px;"
                         class="ag-theme-alpine"
                         [rowData]="invitations$ | async"
                         [columnDefs]="columnDefs"
                         [defaultColDef]="defaultColumnDef"
                         rowSelection='single'
                         [suppressRowClickSelection]="true"
                         (gridReady)="onGridReady($event)"
                         [overlayNoRowsTemplate]="noRowsTemplate"
                         (rowClicked)="onRowClicked($event)">
        </ag-grid-angular>
      </div>
    </div>

    <div class="card card-primary" id="InvitationDetails" *ngIf="showDetail">
      <div class="card-header">
        <div class="row">
          <div class="col-md-10">
            <h4 class="card-title w-100">
              <span>Invitation Detail</span>
            </h4>
          </div>
          <div class="col-md-2 my-auto text-right">
            <i class="fas fa-2x fa-times-circle" style="cursor:pointer" (click)="closeDetail()"></i>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showUpdateForm">
        <form #userAssistUpdateForm="ngForm" (ngSubmit)="updateInvitation(userAssistUpdateForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>User Assistant</label>
                  <input type="text" class="form-control" name="selectedAssistUserEmail" id="selectedAssistUserEmail" [(ngModel)]="selectedAssistUserEmail" readonly>
                  <!--<input type="text" class="form-control" name="selectedAssistUserEmail" id="selectedAssistUserEmail" [(ngModel)]="selectedAssistUserEmail"
                         (keyup)="changeAssistUserID($event)">
                  <input type="button" class="btn btn-secondary my-2" value="Check Linked Email Address"
                         (click)="searchUserByEmailAddress(userAssistUpdateForm.controls.selectedAssistUserEmail)">
                  <br />
                  <span class="align-bottom" *ngIf="showAssistUserIDFound">
                    <i class="fad fa-check-circle fa-2x" style="--fa-primary-color: green; --fa-secondary-color: green; "></i>&nbsp;
                    Email Found!
                  </span>
                  <span class="align-bottom" *ngIf="showAssistUserIDNotFound">
                    <i class="fad fa-times-circle fa-2x" style="--fa-primary-color: darkred; --fa-secondary-color: darkred; "></i>&nbsp;
                    Email Not Found!
                  </span>-->
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Start Date</label>
                  <input type="text" class="form-control" name="assistUserStartDate" id="assistUserStartDate" [(ngModel)]="selectedAssistUserStartDate">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>End Date</label>
                  <input type="text" class="form-control" name="assistUserEndDate" id="assistUserEndDate" [(ngModel)]="selectedAssistUserEndDate">
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <div *ngIf="updateErrorMessage" class="alert alert-danger" role="alert">
                {{ updateErrorMessage }}
              </div>
              <input type="submit" class="btn btn-secondary input-block-level" name="updateButton" id="updateButton" [value]="saving ? 'Saving…' : 'Update'" [disabled]="disableUpdate || saving">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Delete" (click)="deleteInvitation()" [disabled]="saving">
            </div>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="showAddForm">
        <form #userAssistAddForm="ngForm" (ngSubmit)="addInvitation(userAssistAddForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>User Assistant</label>
                  <input type="text" class="form-control" name="addAssistUserEmail" id="addAssistUserEmail" placeholder="enter email address" [(ngModel)]="selectedAssistUserEmail"
                         (keyup)="changeAssistUserID($event)">
                  <input type="button" class="btn btn-secondary my-2" value="Check Linked Email Address"
                         (click)="searchUserByEmailAddress(userAssistAddForm.controls.addAssistUserEmail)">
                  <br/>
                  <span class="align-bottom" *ngIf="showAssistUserIDFound">
                    <i class="fad fa-check-circle fa-2x" style="--fa-primary-color: green; --fa-secondary-color: green; "></i>&nbsp;
                    Email Found!
                  </span>
                  <span class="align-bottom" *ngIf="showAssistUserIDNotFound">
                    <i class="fad fa-times-circle fa-2x" style="--fa-primary-color: darkred; --fa-secondary-color: darkred; "></i>&nbsp;
                    Email Not Found!
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Start Date</label>
                  <input type="text" class="form-control date-slashes" name="addAssistUserStartDate" id="addAssistUserStartDate" placeholder="enter start date as mm/dd/yyyy" maxlength="10" [(ngModel)]="selectedAssistUserStartDate"
                         onkeyup="this.value=this.value.replace(/^(\d\d)(\d)$/g,'$1/$2').replace(/^(\d\d\/\d\d)(\d+)$/g,'$1/$2').replace(/[^\d\/]/g,'')" (focus)="inputFocused($event)">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>End Date</label>
                  <input type="text" class="form-control" name="addAssistUserEndDate" id="addAssistUserEndDate" placeholder="enter end date as mm/dd/yyyy or click No End Date" [(ngModel)]="selectedAssistUserEndDate" [disabled]="isNoEndDate"
                         onkeyup="this.value=this.value.replace(/^(\d\d)(\d)$/g,'$1/$2').replace(/^(\d\d\/\d\d)(\d+)$/g,'$1/$2').replace(/[^\d\/]/g,'')" (focus)="inputFocused($event)">
                  <div class="form-check text-right">
                    <input class="form-check-input" type="checkbox" name="addNoEndDate" id="addNoEndDate" [(ngModel)]="isNoEndDate" (change)="checkNoEndDate($event)">
                    <label class="form-check-label mr-1 mt-1" for="addNoEndDate">
                      No End Date
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div *ngIf="addErrorMessage" class="alert alert-danger" role="alert">
              {{ addErrorMessage }}
            </div>
            <div class="text-center">
              <input type="submit" class="btn btn-secondary input-block-level" name="addButton" id="addButton" value="Add" [disabled]="disableAdd">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Reset" (click)="resetAddForm()">
            </div>
          </div>
        </form>
      </ng-container>

    </div>

  </div>
</div>
